export const FloppyDiscIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M1 1H16L23 8V23H1V1Z" />
        <rect x="7" y="15" width="10" height="8" />
        <path d="M7 8H17" stroke="#020F1F" />
      </g>
    </svg>
  );
};
